export const GRAPH_FILL_COLOR = ['#13388C', '#159A6C', '#15607A', '#1D81A2', '#CECDCD']